import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "../styles/why.css";

export default function WhyChooseUs() {
  const googleRating = "4.8";

  const googleReviewsUrl =
    "https://www.google.com/search?q=VK+BIKE+ON+RENT+Udaipur+reviews";

  const features = [
    {
      title: "24-Hour Service",
      icon: "🕒",
      description:
        "Contact VK Bike On Rent for bike, scooty and taxi rental assistance in Udaipur.",
    },
    {
      title: "Bike & Taxi Options",
      icon: "🏍️",
      description:
        "Choose from available bikes, scooters, sedans and SUVs based on your travel requirements.",
    },
    {
      title: "Quick Booking",
      icon: "🚀",
      description:
        "Contact us on WhatsApp to check current vehicle availability, rental pricing and booking details.",
    },
  ];

  /*
   * Only include genuine customer reviews.
   * Keep review wording faithful to the original source.
   */
  const reviews = [
    {
      name: "Krish Agrawal",
      initial: "K",
      rating: 5,
      text:
        "Very awesome service, good quality bikes, very low cost and great experience.",
    },
    {
      name: "Krupa Kherala",
      initial: "K",
      rating: 5,
      text:
        "Absolutely loved their treatment, well maintained Activa & reasonable prices.",
    },
  ];

  return (
    <section
      className="why-section"
      aria-labelledby="why-title"
    >
      {/* =====================================================
          SECTION INTRODUCTION
      ====================================================== */}

      <header className="why-header">
        <h2
          id="why-title"
          className="section-title"
        >
          Why Choose VK Bike On Rent in Udaipur?
        </h2>

        <p>
          VK Bike On Rent provides bike, scooty and taxi rental
          options for visitors exploring Udaipur. Contact us to
          check current vehicle availability, pricing and booking
          details.
        </p>
      </header>

      {/* =====================================================
          GOOGLE RATING
      ====================================================== */}

      <article
        className="feature-card google-feature"
        aria-labelledby="google-rating-title"
      >
        <div className="google-rating">

          <div
            className="google-rating-info"
            id="google-rating-title"
          >
            <span
              className="google-symbol"
              aria-hidden="true"
            >
              G
            </span>

            <span>
              ⭐ {googleRating} Google Rating
            </span>
          </div>

          <a
            href={googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="google-btn"
            aria-label="View VK Bike On Rent customer reviews on Google"
          >
            View Google Reviews
          </a>

        </div>

        <p>
          See customer reviews and experiences before
          contacting us for your rental requirements.
        </p>
      </article>

      {/* =====================================================
          FEATURES
      ====================================================== */}

      <div className="features-grid">
        {features.map((feature) => (
          <article
            className="feature-card"
            key={feature.title}
          >
            <h3>
              <span aria-hidden="true">
                {feature.icon}
              </span>{" "}
              {feature.title}
            </h3>

            <p>
              {feature.description}
            </p>
          </article>
        ))}
      </div>

      {/* =====================================================
          CUSTOMER REVIEWS
      ====================================================== */}

      <section
        className="reviews-section"
        aria-labelledby="reviews-title"
      >
        <header>
          <h2
            id="reviews-title"
            className="review-title"
          >
            Customer Reviews
          </h2>

          <p className="reviews-intro">
            Read experiences shared by customers who have
            used VK Bike On Rent services.
          </p>
        </header>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={reviews.length > 1}
        >
          {reviews.map((review) => (
            <SwiperSlide key={review.name}>
              <article
                className="review-card"
                aria-label={`Review from ${review.name}`}
              >
                <div className="review-header">

                  <div
                    className="profile-circle"
                    aria-hidden="true"
                  >
                    {review.initial}
                  </div>

                  <div className="review-user">
                    <h3>
                      {review.name}
                    </h3>

                    <div
                      className="stars"
                      role="img"
                      aria-label={`${review.rating} out of 5 stars`}
                    >
                      {"★".repeat(review.rating)}
                    </div>
                  </div>

                </div>

                <blockquote className="review-text">
                  “{review.text}”
                </blockquote>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* =================================================
            GOOGLE REVIEWS CTA
        ================================================== */}

        <div className="reviews-cta">
          <a
            href={googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="google-btn"
            aria-label="Read more VK Bike On Rent reviews on Google"
          >
            Read More Google Reviews
          </a>
        </div>

      </section>
    </section>
  );
}